module.exports = __webpack_public_path__ + "static/media/backIcon.f90e8172.svg";